"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throwNetworkError = throwNetworkError;
exports.throwHttpErrorIfAny = throwHttpErrorIfAny;
exports.returnJsonData = returnJsonData;
exports.returnJson = returnJson;

var _Errors = require("../error/Errors");

function throwNetworkError(e) {
  throw new _Errors.NetworkError(e);
}

function throwHttpErrorIfAny(r) {
  if (r.ok) {
    return r;
  } else {
    if (/json/.test(r.headers.get("content-type"))) {
      return r.json().then(function (json) {
        var error = new _Errors.HttpError(json.msg);
        error.status = r.status;
        throw error;
      });
    } else {
      var error = new _Errors.HttpError(r.statusText);
      error.status = r.status;
      throw error;
    }
  }
}
function returnJsonData(r) {
  //TODO to review
  return r.json().then(function (json) {
    if (json.code) {

      var error = new _Errors.HttpError(json.msg, 500);

      throw error;
    }
    return json.data;
  });
}

function returnJson(r) {
  //TODO to review
  return r.json().then(function (json) {
    if (json.code) {

      var error = new _Errors.HttpError(json.msg, 500);

      throw error;
    }
    return json;
  });
}


//////////////////
// WEBPACK FOOTER
// ../component-common/dist/api/ApiUtils.js
// module id = 796
// module chunks = 0